export default __webpack_public_path__ + "static/media/videoImg.08b84614.svg";